// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__2DFhb","spacer":"Layout_spacer__2KYyW","main":"Layout_main__auk_r","aside":"Layout_aside__gd58g"};